import React from 'react'
import Pagination from './Pagination'

/**
 * The row that sits under a list table: which slice of the total is on screen, and
 * the pager. Leads had this inline; every other list screen kept the pager up in the
 * toolbar, above the rows it controls. Extracted so the arithmetic is written once.
 *
 * `total` is optional because the endpoints spell it differently — totalCount on
 * /customUsers, totalAffiliates on /affiliates, total on /history — and a screen whose
 * total is not wired yet should show the pager alone rather than "of undefined".
 */
const TableFooter = ({ page, limit, total, pageCount, setPage, setLimit }) => {
  const size = Number(limit) || 0
  const current = Number(page) || 1
  const knownTotal = Number.isFinite(Number(total)) && total !== null && total !== undefined
    ? Number(total)
    : null

  let range = null
  if (knownTotal === 0) {
    range = 'No results'
  } else if (knownTotal !== null) {
    const first = (current - 1) * size + 1
    const last = Math.min(current * size, knownTotal)
    range = `Showing ${first}–${last} of ${knownTotal}`
  }

  return (
    <div className="flex justify-between items-center gap-4 px-5 py-4 border-t border-divider flex-wrap">
      <span className="text-sm text-text-secondary whitespace-nowrap">{range}</span>
      <Pagination
        valuePagination={limit}
        pagePagination={page}
        setValuePagination={setLimit}
        setPagePagination={setPage}
        pageItem={pageCount}
      />
    </div>
  )
}

export default TableFooter
